import React, { useState, useContext, useEffect, memo } from "react";
// MODULOS
import Draggable from "react-draggable";

// FUNCIONES
import { replaceCaracteres, trimPropsItem } from "../../../../config/const";

// AXIOS
import clienteAxios from "../../../../config/axios";
// CONTEXT
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../Context/Auth/AuthContext";

import ModalPersona from "../../../Compras/Proveedores/Personas_ISP/Componentes/Modal";
// MATERIAL
import {
  Modal,
  Box,
  Button,
  Divider,
  Typography,
  IconButton,
  Tooltip,
  Autocomplete,
  FormControl,
  TextField,
  Paper,
  MenuItem,
} from "@mui/material";
import { Check, Close, Save } from "@mui/icons-material";
import { useModalStyle } from "../../../../styles/styleModal";
import { objectDefault, validacion } from "../data";
import { useSimpleTable } from "../../../../hooks/useSimpleTable";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import { useDraggable } from "../../../../hooks/useDraggable";
import ListDatoLab from "./ListDatoLab";
import CampoDoc from "../../../components/Campos/CampoDoc";
import { getMessages, localizer } from "../../../Veterinaria/Reservas/helpers";
import { Calendar } from "react-big-calendar";
import { CalendarEvent } from "./CalendarEvent";
import { addDays, format } from "date-fns";
import { useTheme } from "@emotion/react";
// import useMultimediasUpload from "../../../../hooks/useMultimediasUpload";
const seccionDefault = "DATOS PRINCIPALES";
const subseccionDefault = "quimica_sanguinea";
const ModalAnticipos = (props) => {
  //props
  const {
    editar,
    seteditar,
    setopen,
    open,
    ObjectoActivo,
    changeObjetoActivoState,
    socket,
  } = props;
  const [item, setitem] = useState(ObjectoActivo);
  const [personaSeleccionada, setpersonaSeleccionada] = useState({
    persona: [],
  });
  const [veterinariosData, setveterinariosData] = useState([]);
  const {} = item;
  // const {
  //   setmodificoImagenes,
  //   subirImagenes,
  //   imagenes,
  //   setimagenes,
  // } = useMultimediasUpload("new_horarios");
  const { mostrarAlerta } = useContext(AlertaContext);
  const { usuario } = useContext(AuthContext);

  // SECCION

  const [seccionActive, setseccionActive] = useState(seccionDefault);
  const [subseccionActive, setsubseccionActive] = useState(subseccionDefault);
  // DE SIEMPRE
  const [cargando, setcargando] = useState(false);
  const [error, seterror] = useState({});
  const clases = useModalStyle();

  useEffect(() => {
    // const getequipoData = async () => {
    //   try {
    //     const resequipoData = await clienteAxios("/maquinarias/filtro/0");
    //     setequipoData(resequipoData.data.data);
    //   } catch (error) {
    //     setequipoData([]);
    //   }
    // };
    // if (!equipoData) {
    //   getequipoData();
    // }
    console.log(ObjectoActivo);

    setitem(ObjectoActivo);

    // eslint-disable-next-line
  }, [ObjectoActivo]);
  const [ubicacionesData, setubicacionesData] = useState([]);
  const getubicacionesData = async () => {
    try {
      const res = await clienteAxios.get(`/ubicaciones_trabajo/todo`);
      console.log({ res });

      setubicacionesData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const [usuariosData, setusuariosData] = useState([]);
  const getusuariosData = async () => {
    try {
      const res = await clienteAxios.get(
        `proveedores/listar/por/perfil?perfil=USUARIO`
      );
      console.log({ res });

      setusuariosData(
        res.data.map((item) => ({
          dht_id_persona: item.perId,
          cedula: item.perDocNumero,
          nombre: item.perNombre,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };
  const [tipoTurno, settipoTurno] = useState({
    tt_nombre_turno: "",
    tt_color: "",
    tt_hora_inicio: "",
    tt_hora_fin: "",
    tt_id: "",
  });
  const [tipoTurnosData, settipoTurnosData] = useState([]);
  const gettipoTurnosData = async () => {
    try {
      const res = await clienteAxios.get(`/tipos_turno/todo`);
      console.log({ res });

      settipoTurnosData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getubicacionesData();
    gettipoTurnosData();
    getusuariosData();
  }, []);

  const defaultActive = () => {
    changeObjetoActivoState(objectDefault);
    setitem(objectDefault);
    setopen(false);
    seteditar(false);
    seterror({});
    setcargando(false);
    setseccionActive(seccionDefault);
    // setimagenes([]);
  };
  const handleChange = (e) => {
    const res = replaceCaracteres(e.target.value);
    setitem({
      ...item,
      [e.target.name]: res,
    });
  };
  const fixDate = (date) =>
    new Date(Date.parse(date) - new Date().getTimezoneOffset() * 60 * 1000)
      .toISOString()
      .substring(0, 16);
  const handleCrear = async () => {
    try {
      if (validacion(item, setitem, seterror)) {
        return mostrarAlerta("Seleccione al menos una fecha y la ubicación", "error");
      }

      const res = await clienteAxios.get;
      setcargando(true);
      console.log(
        trimPropsItem({
          ...item,

          // actaFotos: resDocumentos,
          tabla: "new_horarios",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          h_usuario: usuario.usuario,
          h_empresa: usuario.rucempresa,
          fechas: item.fechas.map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
            dht_id: 0,
            dht_id_horario: 0,
          })),
        })
      );

      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,

          // actaFotos: resDocumentos,
          tabla: "new_horarios",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          h_usuario: usuario.usuario,
          h_empresa: usuario.rucempresa,
          fechas: item.fechas.map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
            dht_id: 0,
            dht_id_horario: 0,
          })),
        })
      );
      setcargando(false);
      return defaultActive();
    } catch (error) {
      setcargando(false);
      mostrarAlerta("Hubo un error", "error");
      return defaultActive();
    }
  };
  const compararViejosYNuevosFechas = (fechasAntiguas, fechasNuevas) => {
    return fechasNuevas.map((fechaNueva) => {
      const existeFecha = fechasAntiguas.find((fechaAntigua) => {
        console.log({
          fechaAntigua: fixDate(fechaAntigua.desde),
          fechaNueva: fixDate(fechaNueva.desde),
          fechaAntiguaParse: Date.parse(fechaAntigua.desde),
          fechaNuevaParse: Date.parse(fechaNueva.desde),
        });
        return (
          fixDate(fechaAntigua.desde) === fixDate(fechaNueva.desde) &&
          fechaAntigua.dht_id_tipo_turno === fechaNueva.dht_id_tipo_turno
        );
      });
      console.log({ existeFecha });

      return existeFecha
        ? existeFecha
        : { ...fechaNueva, dht_id: 0, dht_id_horario: item.h_id };
    });
  };

  const handleEditar = async () => {
    try {
      if (validacion(item, setitem, seterror)) {
        return mostrarAlerta("Seleccione al menos una fecha y la ubicación", "error");
      }

      console.log(
        compararViejosYNuevosFechas(ObjectoActivo.fechas, item.fechas)
      );

      setcargando(true);
      console.log(
        trimPropsItem({
          ...item,
          fechas_antiguo: ObjectoActivo.fechas.map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
          })),
          fechas: compararViejosYNuevosFechas(
            ObjectoActivo.fechas,
            item.fechas
          ).map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
          })),

          // actaFotos: resDocumentos,
          tabla: "new_horarios",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          h_usuario: usuario.usuario,
          h_empresa: usuario.rucempresa,
        })
      );

      socket.current.emit(
        "client:actualizarData",
        trimPropsItem({
          ...item,
          fechas_antiguo: ObjectoActivo.fechas.map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
          })),
          fechas: compararViejosYNuevosFechas(
            ObjectoActivo.fechas,
            item.fechas
          ).map((fecha) => ({
            ...fecha,
            desde: fixDate(fecha.desde),
            hasta: fixDate(fecha.hasta),
          })),

          // actaFotos: resDocumentos,
          tabla: "new_horarios",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          h_usuario: usuario.usuario,
          h_empresa: usuario.rucempresa,
        })
      );
      setcargando(false);
      return defaultActive();
    } catch (error) {
      console.log({ error });

      setcargando(false);
      mostrarAlerta("Hubo un error", "error");
      return defaultActive();
    }
  };
  const handleGuardar = () => {
    if (editar) {
      handleEditar();
    } else {
      handleCrear();
    }
  };
  const theme = useTheme();
  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.dht_color,
      borderRadius: "0px",
      color: theme.palette.getContrastText(event.dht_color),
    };
    return { style };
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Draggable handle="#handle">
          <Box display="flex" justifyContent="center">
            <div
              style={{
                borderRadius: "15px",
                position: "absolute",
                overflow: "scroll",
                maxHeight: "95vh",
              }}
              className={clases.paper}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <Typography
                    style={{ cursor: "-webkit-grab" }}
                    id="handle"
                    variant="button"
                    color="initial"
                    align="center"
                  >
                    {`${editar ? "Editar" : "Agregar"} Horarios.`}
                  </Typography>
                  <Tooltip title={"Guardar"} followCursor placement="top-start">
                    <IconButton
                      onClick={() => {
                        if (validacion(item, setitem, seterror)) {
                          return mostrarAlerta(
                            "Seleccione al menos una fecha y la ubicación",
                            "error"
                          );
                        }

                        handleGuardar();
                      }}
                    >
                      <Save color="secondary" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <IconButton
                    onClick={() => {
                      defaultActive();
                    }}
                  >
                    <Close color={"error"} />
                  </IconButton>
                </Box>
              </Box>
              <Divider />
              <Box display="flex" justifyContent="space-between" width="100%">
                <Box display={"flex"} flexWrap={"wrap"}>
                  {/* <Button
                    variant={
                      seccionActive === "DATOS PRINCIPALES"
                        ? "contained"
                        : error.actaDocCliente
                        ? "outlined"
                        : "null"
                    }
                    color={error.actaDocCliente ? "error" : "primary"}
                    disableElevation
                    className={clases.buttonTab}
                    size="small"
                    onClick={() => setseccionActive("DATOS PRINCIPALES")}
                  >
                    DATOS PRINCIPALES
                  </Button> */}
                </Box>
              </Box>
              <Divider />
              <Box className={clases.container}>
                {seccionActive === "DATOS PRINCIPALES" && (
                  <>
                    <FormControl className={clases.formD}>
                      <Autocomplete
                        filterOptions={(x) => x}
                        options={ubicacionesData.map((item) => {
                          return (
                            item.ubicacion +
                            "/+/" +
                            item.puesto +
                            "/+/" +
                            item.id
                          );
                        })}
                        getOptionLabel={(option) => {
                          return option.replace("/+/", " - ").split("/+/")[0];
                        }}
                        id="controlled-demo"
                        value={
                          item.ubicacion === ""
                            ? ""
                            : item.ubicacion + " - " + item.puesto
                        }
                        paperprops
                        onChange={async (event, newValue) => {
                          if (newValue) {
                            const options = newValue.split("/+/");

                            setitem({
                              ...item,
                              ubicacion: options[0],
                              puesto: options[1],

                              h_id_ubicacion: options[2],
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label="Ubicación"
                            // label={"Ubicación"}
                            fullWidth
                            error={error.ubicacion}
                          />
                        )}
                      />
                    </FormControl>
                    <TextField
                      className={clases.formD}
                      value={tipoTurno.tt_id}
                      name="tt_id"
                      onChange={(e) => {
                        const selected = tipoTurnosData.find(
                          (item) =>
                            String(item.tt_id) === String(e.target.value)
                        );
                        if (selected) {
                          settipoTurno({
                            tt_nombre_turno: selected.tt_nombre_turno,
                            tt_hora_inicio: selected.tt_hora_inicio,
                            tt_hora_fin: selected.tt_hora_fin,
                            tt_color: selected.tt_color,
                            tt_id: selected.tt_id,
                          });
                        }
                      }}
                      InputProps={{
                        sx: {
                          backgroundColor: `${tipoTurno.tt_color} !important`,
                          color: (theme) =>
                            !tipoTurno.tt_color
                              ? "black"
                              : theme.palette.getContrastText(
                                  tipoTurno.tt_color
                                ),
                        },
                      }}
                      size="small"
                      select
                      label="Tipo Turno"
                      InputLabelProps={{ shrink: true }}
                      SelectProps={{ displayEmpty: true }}
                    >
                      <MenuItem value="" disabled>
                        Seleccione Tipo
                      </MenuItem>
                      {tipoTurnosData.map((item) => (
                        <MenuItem
                          key={item.tt_id}
                          value={item.tt_id}
                          sx={{
                            background: `${item.tt_color} !important`,
                            color: (theme) =>
                              theme.palette.getContrastText(item.tt_color),
                          }}
                        >
                          {`${item.tt_nombre_turno}: ${item.tt_hora_inicio} - ${item.tt_hora_fin}`}
                        </MenuItem>
                      ))}
                    </TextField>
                    {/* perId: 102,
          perDocNumero: '2350320954',
          perNombre: 'LOPEZ ANDRADE ADAMARIS CRISTINA' */}
                    <Box className={clases.formD}>
                      <ListDatoLab
                        onlyOne
                        readOnly={false}
                        error={error}
                        item={personaSeleccionada}
                        setitem={(e) => {
                          setpersonaSeleccionada(e);
                        }}
                        data={usuariosData}
                        propiedad={personaSeleccionada.persona}
                        propiedadString={"persona"}
                        propiedadId={"dht_id_persona"}
                        propiedadMostrar1={"cedula"}
                        propiedadMostrar2={"nombre"}
                        //   dht_id_persona: 106,
                        //   cedula: "2300899800",
                        //   nombre: "TACURI LEONES NATASHA MAHOLY",
                      />
                    </Box>

                    <Box className={clases.formD} overflow={"scroll"}>
                      <Calendar
                        toolbar={true}
                        culture="es"
                        localizer={localizer}
                        events={item.fechas}
                        popup={false} // <--- muestra todos los eventos, no el popup "+ver más"
                        showMore={true} // <--
                        defaultView={"month"}
                        style={{
                          height: "1200px",
                          color: "black",
                        }}
                        startAccessor="desde"
                        endAccessor="hasta"
                        messages={getMessages()}
                        eventPropGetter={eventStyleGetter}
                        components={{
                          event: (event) => (
                            <CalendarEvent
                              event={event}
                              // changeObjetoActivoStatePropietario={
                              //   changeObjetoActivoStatePropietario
                              // }
                              // setopenPropietarioModal={setopenPropietarioModal}
                              // setopenConfirmDialog={setopenConfirmDialog}
                            />
                          ),
                        }}
                        onDoubleClickEvent={() => {}}
                        onSelectEvent={() => {}}
                        selectable
                        onSelectSlot={(e) => {
                          if (
                            !(
                              tipoTurno.tt_hora_inicio &&
                              personaSeleccionada.persona.length > 0
                            )
                          ) {
                            return mostrarAlerta(
                              "Seleccione una persona y un tipo de turno",
                              "error"
                            );
                          }
                          console.log({ e });

                          function generarFechasTurno(
                            slots,
                            tipoTurno,
                            fechasExistentes = []
                          ) {
                            const nuevasFechas = [];
                            const eliminados = [];

                            slots.forEach((slot) => {
                              const fechaBase = new Date(slot);

                              // Construye la fecha inicial con la hora de inicio del turno
                              const [
                                hIni,
                                mIni,
                                sIni,
                              ] = tipoTurno.tt_hora_inicio.split(":");
                              const desde = new Date(fechaBase);
                              desde.setHours(
                                Number(hIni),
                                Number(mIni),
                                Number(sIni),
                                0
                              );

                              // Construye la fecha final con la hora de fin del turno
                              const [
                                hFin,
                                mFin,
                                sFin,
                              ] = tipoTurno.tt_hora_fin.split(":");
                              let hasta = new Date(fechaBase);
                              hasta.setHours(
                                Number(hFin),
                                Number(mFin),
                                Number(sFin),
                                0
                              );

                              // Si la hora de fin es menor o igual a la de inicio, avanza al día siguiente
                              if (
                                Number(hFin) < Number(hIni) ||
                                (Number(hFin) === Number(hIni) &&
                                  Number(mFin) <= Number(mIni))
                              ) {
                                hasta = addDays(hasta, 1);
                              }

                              // Formatea las fechas como "YYYY-MM-DD HH:mm:ss"
                              const desdeStr = format(
                                desde,
                                "yyyy-MM-dd HH:mm:ss"
                              );
                              const hastaStr = format(
                                hasta,
                                "yyyy-MM-dd HH:mm:ss"
                              );

                              // Verifica si ya existe una fecha igual con el mismo tipoTurno (dht_id_tipo_turno)
                              const idxExistente = fechasExistentes.findIndex(
                                (f) => {
                                  return (
                                    new Date(f.desde)
                                      .toISOString()
                                      .substring(0, 10) ===
                                      new Date(desde)
                                        .toISOString()
                                        .substring(0, 10) &&
                                    f.dht_id_persona ===
                                      personaSeleccionada.persona[0]
                                        .dht_id_persona &&
                                    String(f.dht_id_tipo_turno) ===
                                      String(tipoTurno.tt_id)
                                  );
                                }
                              );

                              if (idxExistente === -1) {
                                // No existe, agregar
                                nuevasFechas.push({
                                  desde: desdeStr,
                                  hasta: hastaStr,
                                  dht_id_tipo_turno: tipoTurno.tt_id,
                                  dht_id: 0,
                                  dht_id_horario: 0,
                                  dht_color: tipoTurno.tt_color,
                                  ...personaSeleccionada.persona[0],
                                });
                              } else {
                                // Ya existe, eliminar y agregar a eliminados
                                eliminados.push(fechasExistentes[idxExistente]);
                              }
                            });

                            return { nuevasFechas, eliminados };
                          }
                          function filterUniqueDays(timestamps) {
                            const seenDays = new Set();
                            return timestamps.filter((timestamp) => {
                              const day = new Date(timestamp)
                                .toISOString()
                                .split("T")[0]; // Extrae YYYY-MM-DD
                              if (seenDays.has(day)) return false;
                              seenDays.add(day);
                              return true;
                            });
                          }

                          // Ejemplo de uso en tu handler:
                          console.log(
                            filterUniqueDays(
                              e.slots.map((slot) =>
                                new Date(slot).toISOString()
                              )
                            )
                          );

                          const {
                            nuevasFechas,
                            eliminados,
                          } = generarFechasTurno(
                            filterUniqueDays(
                              e.slots.map((slot) =>
                                new Date(slot).toISOString()
                              )
                            ),
                            tipoTurno,
                            item.fechas
                          );

                          // Para actualizar el state:
                          setitem((prev) => {
                            const fechas = [
                              // Elimina las fechas que están en eliminados
                              ...(prev.fechas || []).filter(
                                (f) =>
                                  !eliminados.some(
                                    (el) =>
                                      el.desde === f.desde &&
                                      el.hasta === f.hasta &&
                                      String(el.dht_id_tipo_turno) ===
                                        String(f.dht_id_tipo_turno)
                                  )
                              ),
                              ...nuevasFechas,
                            ].map((event) => ({
                              ...event,
                              desde: event.desde ? new Date(event.desde) : null,
                              hasta: event.hasta ? new Date(event.hasta) : null,
                            }));
                            console.log({ fechas });

                            return {
                              ...prev,
                              fechas,
                            };
                          });
                        }}
                      />
                    </Box>
                    {/* <FormControl fullWidth className={clases.formD}>
                      <Autocomplete
                        filterOptions={(x) => x}
                        options={mascotasData.map((item) => {
                          return (
                            item.mascNombre +
                            "/+/" +
                            item.mascPerNombre +
                            "/+/" +
                            item.mascId
                          );
                        })}
                        getOptionLabel={(option) => {
                          return option.replace("/+/", " - ").split("/+/")[0];
                        }}
                        id="controlled-demo"
                        value={item.lc_nombre_mascota}
                        paperprops
                        onChange={async (event, newValue) => {
                          if (newValue) {
                            const options = newValue.split("/+/");
                            console.log(options, mascotasData);

                            const itemF = mascotasData.find((itemMascota) => {
                              return (
                                String(itemMascota.mascId) ===
                                String(options[2])
                              );
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={error.lc_nombre_mascota}
                            label="Paciente"
                            fullWidth
                            onChange={async (e) => {
                              if (e.target.value === "") {
                                return;
                              }
                              try {
                                const res = await clienteAxios.get(
                                  `/mascotas/filtro/0?search=${e.target.value}`
                                );
                                if (!res.data.data) {
                                  return mostrarAlerta(res.data.msg, "error");
                                }

                                setmascotasData(res.data.data);
                              } catch (error) {}
                            }}
                          />
                        )}
                      />
                    </FormControl>

                    <TextField
                      disabled
                      className={clases.formD}
                      label="Edad"
                      value={item.lc_edad_mascota}
                      name="lc_edad_mascota"
                      error={error.lc_edad_mascota}
                      onChange={handleChange}
                    /> */}
                  </>
                )}

                {/* <Box display="flex" justifyContent="space-between" width="100%">
                  <Box display={"flex"} flexWrap={"wrap"}>
                    {[
                      "quimica_sanguinea",
                      "hematologia",
                      "hemostasia_coagulacion",
                      "paneles_bioquimica",
                    ].map((item) => (
                      <Button
                        variant={
                          subseccionActive === item
                            ? "contained"
                            : error.actaDocCliente
                            ? "outlined"
                            : "null"
                        }
                        color={error.actaDocCliente ? "error" : "secondary"}
                        disableElevation
                        className={clases.buttonTab}
                        size="small"
                        onClick={() => setsubseccionActive(item)}
                      >
                        {item.replace("_", " ")}
                      </Button>
                    ))}
                  </Box>
                </Box> */}
                {/* {subseccionActive === "quimica_sanguinea" && (
                  <ListDatoLab
                    readOnly={false}
                    error={error}
                    item={item}
                    setitem={(e) => {
                      setitem(e);
                    }}
                    data={quimica_sanguineaData}
                    propiedad={item.lc_quimica_sanguinea}
                    propiedadString={"lc_quimica_sanguinea"}
                    propiedadId={"qs_id"}
                    propiedadMostrar1={"qs_categoria"}
                    propiedadMostrar2={"qs_parametro"}
                  />
                )}
               */}
              </Box>

              <Divider />
              <Box display="flex" width="100%" justifyContent="space-between">
                <Box width="100%" display="flex" justifyContent="flex-end">
                  <Button
                    style={{ width: "30%" }}
                    variant="contained"
                    color="primary"
                    disabled={cargando}
                    onClick={() => {
                      if (validacion(item, setitem, seterror)) {
                        return mostrarAlerta(
                          "Seleccione al menos una fecha y la ubicación",
                          "error"
                        );
                      }

                      handleGuardar();
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Box>
            </div>
          </Box>
        </Draggable>
      </Box>
    </Modal>
  );
};

export default memo(ModalAnticipos);
